import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/jobs/confirmedShipmentDatesReportActions'
import * as api from '../../../api/reports/jobs/confirmedShipmentDatesReport'

function* confirmedShipmentDatesReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.CONFIRMED_SHIPMENT_DATES_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CONFIRMED_SHIPMENT_DATES_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* confirmedShipmentDatesReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({
      type: constants.CONFIRMED_SHIPMENT_DATES_REPORT_GET_ORGANIZATION_LIST.SUCCESS,
      payload
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CONFIRMED_SHIPMENT_DATES_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* confirmedShipmentDatesReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.CONFIRMED_SHIPMENT_DATES_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CONFIRMED_SHIPMENT_DATES_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchconfirmedShipmentDatesReportGetJobList() {
  yield takeLatest(
    constants.CONFIRMED_SHIPMENT_DATES_REPORT_GET_JOB_LIST.ACTION,
    confirmedShipmentDatesReportGetJobList
  )
}

function* watchconfirmedShipmentDatesReportGetOrganizationList() {
  yield takeLatest(
    constants.CONFIRMED_SHIPMENT_DATES_REPORT_GET_ORGANIZATION_LIST.ACTION,
    confirmedShipmentDatesReportGetOrganizationList
  )
}

function* watchconfirmedShipmentDatesReportGetFullReport() {
  yield takeLatest(
    constants.CONFIRMED_SHIPMENT_DATES_REPORT_GET_FULL_REPORT.ACTION,
    confirmedShipmentDatesReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchconfirmedShipmentDatesReportGetOrganizationList),
    fork(watchconfirmedShipmentDatesReportGetFullReport),
    fork(watchconfirmedShipmentDatesReportGetJobList)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/jobs/confirmedShipmentDatesSaga.js